import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Explotacion } from './entities/explotacion.entity';
import { Contrato } from './entities/contrato.entity';
import { ContratosUser } from './entities/ContratosUser.entity';
import { UsuarioOnline } from './entities/UsuarioOnline.entity';
import { Component, OnInit, ElementRef } from '@angular/core';
import { SessionService } from './services/session.service';
import { UserService } from './services/user.service';
import { HttpService } from './services/http.service';
import { BlockUIService } from './services/blockui.service';
import { AlertService } from './services/alert.service';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { Factura } from './entities/factura.entity';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { UserServiceA2P } from './services/userA2P.service';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [UserService, HttpService, BlockUIService, AlertService, UserServiceA2P]
})
export class AppComponent implements OnInit {
  public firstName: string;
  public lastName: string;
  public isAuthenticated: Boolean = false;
  public endDateTime: string;
  public explotaciones: Explotacion[];
  public blockUI: Boolean;
  public user: ContratosUser;
  public currentYear: number = new Date().getFullYear();

  public currentRoute: string;
  public title: string;
  public version: string;
  public webApiEndPoint: string;
  public imagesDirectory: string;
  public _opened = false;
  public _modeNum = 2;
  public _positionNum = 0;
  public _dock = false;
  public _closeOnClickOutside = true;
  public _closeOnClickBackdrop = false;
  public _showBackdrop = false;
  public _animate = true;
  public _trapFocus = true;
  public _autoFocus = true;
  public _keyClose = false;
  public _autoCollapseHeight: number = null;
  public _autoCollapseWidth: number = null;

  public _MODES: Array<string> = ['over', 'push', 'slide'];
  public _POSITIONS: Array<string> = ['left', 'right', 'top', 'bottom'];
  private template: string;
  public condiciones: string;
  public politica: string;
  public pie: string;
  public urlApi: string;
  public isMain: boolean;

  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private sessionService: SessionService,
    private userService: UserService,
    private httpService: HttpService,
    private blockUIService: BlockUIService,
    public router: Router,
    private elementRef: ElementRef,
    private spinnerService: Ng4LoadingSpinnerService,
    private userServiceA2P : UserServiceA2P) {
    const native = this.elementRef.nativeElement;
    this.imagesDirectory = native.getAttribute('imagesDirectory');
    sessionService.apiServer = environment.urlApi; // this.webApiEndPoint;
    sessionService.version = environment.version;
  }

  public ngOnInit() {
    this.pie = environment.pie;
    this.sessionService.sessionEvent.subscribe((user: ContratosUser) => this.onAuthenication(user));
    this.template = `<img src="assets/images/Eclipse-2.1s-200px.gif" class="logo oficina" />`;
    if (localStorage.getItem('Oficina.WebApi.Angular4.Token') === '' || localStorage.getItem('Oficina.WebApi.Angular4.Token') === null) {
      this.router.navigate(['/public/login']);
    } else {
      this.httpService.showSpinner();
      this.blockUIService.blockUIEvent.subscribe((event: any) => this.blockUnBlockUI(event));
      this.blockUIService.blockUIEvent.emit({
        value: true
      });

      const usuarionew: UsuarioOnline = new UsuarioOnline();
      const user: ContratosUser = new ContratosUser();
      user.UsuarioOnline = usuarionew;

      this.userService.getExplotaciones().subscribe(
        response => {
          this.cargarExplotaciones(response);
          this.userService.authenticate(user).subscribe(
            authenticatedUser => this.authenticateOnSuccess(authenticatedUser),
            error => this.authenticateOnError(error)
          );
        },
        error => this.authenticateOnError(error)
      );
    }
  }

  private blockUnBlockUI(event) {
    this.blockUI = event.value;
  }

  showHeaderB(): boolean {
    let valor = false;
    if (this.sessionService.contratos === undefined) {
      valor = true;
    }
    switch (this.router.url) {
      case ('/'):
      case ('/public/login'):
      case ('/public/register'):
      case ('/public/resetPassword'):
      case ('/public/contactpublic'):
        valor = true;
        break;
    }
    return valor;
  }

  private authenticateOnSuccess(response: ContratosUser) {
    if (response.UsuarioOnline.ReturnStatus === false) {
      this.authenticateOnError(null);
      return;
    }
    if (response.UsuarioOnline.IsAuthenticated === false) {
      this.authenticateOnError(null);
      return;
    }

    this.userService.getContratos().subscribe(
      contratos => this.restoreSession(response, contratos),
      error => this.authenticateOnError(error)
    );
  }

  private restoreSession(response: ContratosUser, contratos: Contrato[]) {
    const user: ContratosUser = new ContratosUser();
    const userOnline: UsuarioOnline = new UsuarioOnline();
    let facturas: Factura[] = [];
    userOnline.EMail = response.UsuarioOnline.EMail;
    userOnline.Nombre = response.UsuarioOnline.Nombre;
    userOnline.Login = response.UsuarioOnline.Login;
    userOnline.Telefono1 = response.UsuarioOnline.Telefono1;
    userOnline.Telefono2 = response.UsuarioOnline.Telefono2;
    userOnline.EFactura = response.UsuarioOnline.EFactura;
    userOnline.Explotacion = response.UsuarioOnline.Explotacion;
    // tslint:disable-next-line:forin
    for (const i in contratos) {
      if (contratos[i].Facturas.length > 0) {
        facturas = contratos[i].Facturas;
        contratos[i].Facturas = facturas;
      }
    }
    user.UsuarioOnline = userOnline;
    user.Contratos = contratos;
    this.firstName = response.UsuarioOnline.Nombre;
    this.isAuthenticated = true;
    this.sessionService.authenticated(user, this.explotaciones);
    this.sessionService.sessionRestored.next(true);
    this.httpService.hideSpinner();
    this.blockUIService.blockUIEvent.emit({ value: false });
    this.currentRoute = this.router.url;
    if (this.currentRoute === '/public/login' ||
      (this.currentRoute === '/' && (!window.location.hash || window.location.hash === '#/' || window.location.hash === '#'))) {
      this.router.navigate(['/home/home']);
    }
  }

  private authenticateOnError(error) {
    this.httpService.hideSpinner();
    this.sessionService.sessionRestored.next(false);
    this.router.navigate(['/public/login']);
    this.isAuthenticated = false;
    this.blockUIService.blockUIEvent.emit({
      value: false
    });
  }

  private onAuthenication(user: ContratosUser): void {
    this.firstName = user.UsuarioOnline.Nombre;
    this.isAuthenticated = true;
  }

  public logout() {
    this.firstName = '';
    this.lastName = '';
    this.isAuthenticated = false;
    this.sessionService.logout();
    if (typeof (Storage) !== 'undefined') {
      localStorage.setItem('Oficina.WebApi.Angular4.Token', '');
    }
    this.router.navigate(['public/login']);
  }

  getfooterStyle() {
    let footerStyle: string;
    if (this.router.url.startsWith('/home') || this.router.url.startsWith('/public/register')
      || this.router.url.startsWith('/public/contactpublic')) {
      footerStyle = 'site-footer';
    } else {
      footerStyle = 'site-footer footer-login';
    }
    if (this.router.url.startsWith('/home/home')) {
      footerStyle = 'site-footer footer-login';
    }
    if (this.sessionService.isAuthenticated === true && this.sessionService.contratoSelected !== undefined
      && this.sessionService.contratoSelected.Facturas !== undefined) {
      if (this.sessionService.contratoSelected.Facturas.length === 0 && this.router.url.startsWith('/home/consumofactura')) {
        footerStyle = 'site-footer footer-login';
      }
    }
    return footerStyle;
  }

  public _toggleOpened(): void {
    this._opened = !this._opened;
  }

  public _onOpenStart(event): void {
    this._opened = true;
  }

  public _onCloseStart(event): void {
    this._opened = false;
  }

  public _onClosed(): void {
  }

  public CargarCondicioneslegales() {
    if (this.sessionService.datosExplotacion.CondicionesEnvio !== null) {
      this.condiciones = this.sessionService.datosExplotacion.CondicionesEnvio;
    } else {
      this.condiciones = '<p>Seleccione población</p>';
    }
  }

  public CargarPoliticaPrivacidad() {
    if (this.sessionService.datosExplotacion.PoliticaEnvio !== null) {
      this.politica = this.sessionService.datosExplotacion.PoliticaEnvio;
    } else {
      this.politica = '<p>Seleccione población</p>';
    }
  }

  private cargarExplotaciones(response): void {
    this.explotaciones = response;
  }

  private appendGaTrackingCode() {
    try {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
        ga('create', ' ` + environment.ganalytics + ` ', 'auto');    `;
      document.head.appendChild(script);
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }

  public onLoadGoogleCookies(storeGoogleCookies: any) {
    if (storeGoogleCookies) { this.appendGaTrackingCode();
    this.googleAnalyticsService.subscribeGoogle(); }
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/app.component.ts